module.exports = __webpack_public_path__ + "static/media/Satoshi-Bold.fc3b9a87.woff";